import script from "./MoneyView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MoneyView.vue?vue&type=script&setup=true&lang=ts"

import "./MoneyView.vue?vue&type=style&index=0&id=38883968&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38883968"]])

export default __exports__